// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__sYeYW","logo":"sidebar_logo__b3A3z","logoText":"sidebar_logoText__tCKk-","logoIcon":"sidebar_logoIcon__ysF2s"};